import { normalizeGiftCardId } from "./eGiftCardRequestMapper";

export interface MerchantBrandItemCampaignSelection {
  merchantBrandItemId: string;
  pointRequired: number;
}

export function toMerchantBrandItemCampaignSelections(
  giftCards: Array<{ id?: string; points: number }>,
): MerchantBrandItemCampaignSelection[] {
  return giftCards.flatMap((card) =>
    card.id
      ? [{ merchantBrandItemId: normalizeGiftCardId(card.id), pointRequired: card.points }]
      : [],
  );
}

export const getEGiftCardCampaignRequestKey = (
  merchantBrandId: string,
  merchantBrandItems: MerchantBrandItemCampaignSelection[],
  couponId?: string,
) => {
  if (!merchantBrandId || merchantBrandItems.length === 0) return null;

  const merchantBrandItemKeys = merchantBrandItems
    .map(
      ({ merchantBrandItemId, pointRequired }) =>
        `${normalizeGiftCardId(merchantBrandItemId)}_${pointRequired}`,
    )
    .sort()
    .join(",");

  return `${merchantBrandId}:${merchantBrandItemKeys}:${couponId ?? ""}`;
};
